import styled from "styled-components";

/**
 * Layout hook only. Each screen styles the control through
 * `className` (`.common-date-picker`) and `popupClassName`
 * (`.common-date-picker-dropdown`).
 */
export const CommonDatePickerWrap = styled.div`
  display: block;
  width: 100%;
  max-width: 100%;

  .common-date-picker.ant-picker {
    width: 100%;
  }
`;

/** Inline filter ranges (Apps list/store). Keeps antd RangePicker natural width. */
export const CommonDateRangePickerWrap = styled.div`
  display: inline-block;
  max-width: 100%;

  .common-date-picker.ant-picker {
    width: auto;
  }
`;
